import React, { useEffect, useState } from "react";
import { ShowProps, useDataProvider } from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid } from "@material-ui/core";
import RegularStudentScheduleTable from "./components/RegularStudentScheduleTable";
import CcaStudentScheduleTable from "./components/CcaStudentScheduleTable";
import CcaScheduleDisabledComponent from "./components/CcaScheduleDisabledComponent";
import { StudentResources } from "utils/tools";

const StudentSchedule = (props: ShowProps) => {
  const provider = useDataProvider();
  const [school, setSchool] = useState<ISchool>();

  const { id } = props;
  const studentResources = StudentResources(Number(id));

  useEffect(() => {
    provider
      .getOne("schools", { id: Number(studentResources.schoolId) })
      .then(({ data }) => {
        setSchool(data as ISchool);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <RegularStudentScheduleTable {...props} />
      </Grid>

      <Grid item xs={12}>
        {school && school.isCcaSettingEnable ? (
          <CcaStudentScheduleTable {...props} />
        ) : (
          <CcaScheduleDisabledComponent
            schoolId={Number(studentResources.schoolId)}
          />
        )}
      </Grid>
    </SanitizedGrid>
  );
};

export default StudentSchedule;
